<template>
  <div class="cart__crosssell" v-show="products.length">
    <h3>{{ $t('Other customers also bought') }}</h3>
    <div class="catalog__category-list slider__container" :class="{_active : products.length < 5}">
      <swiper ref="crossSellSlider" :options="slideOptions">
        <swiper-slide v-for="product in products" :key="product.product_id">
          <product-list-item :data-source="'dataSource'" :product="product" type="crosssell"></product-list-item>
        </swiper-slide>
      </swiper>
      <div class="slider__controls crossSellSlider">
        <div class="slider__control prev" slot="button-prev"></div>
        <div class="slider__control next" slot="button-next"></div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import {Component, Vue, Prop} from 'vue-property-decorator';
  import ServiceContainer from '@flashpointbv/solar-service-container';
  import {Swiper, SwiperSlide, directive} from 'vue-awesome-swiper';
  import 'swiper/css/swiper.css';
  import {apiClient} from '../../../shared/services/api-client';
  import {enhancedEcommerce} from '../../../shared/helpers/enhanced-ecommerce';
  import {SolarDataLayer} from '@flashpointbv/solar-datalayer/dist';

  @Component({
    name: 'checkout-cart-cross-sell',
    components: {
      'product-list-item': ServiceContainer().getComponent('catalog-product-list-item'),
      Swiper,
      SwiperSlide
    },
    directives: {
      swiper: directive
    }
  })

  export default class extends Vue {
    @Prop({default: ''}) readonly skus!: string;
    @Prop({default: 12}) readonly limit!: number;

    private products: Array<object> = [];

    private slideOptions: object = {
      slidesPerView: 2,
      spaceBetween: 12,
      navigation: {
        nextEl: `.crossSellSlider .next`,
        prevEl: `.crossSellSlider .prev`
      },
      breakpoints: {
        768: {
          slidesPerView: 3
        },
        1024: {
          slidesPerView: 4
        },
        1200: {
          slidesPerView: 5
        }
      }
    };

    private async created(): Promise<void> {
      if (!this.skus) {
        return;
      }

      this.products = await this.fetchProducts();

      if (!this.products.length) {
        return;
      }

      enhancedEcommerce.addProductImpressions(this.products);
      SolarDataLayer.init().addViewItemsList(this.products, 'Cart cross-sell');
    }

    private async fetchProducts(): Promise<Array<object>> {
      try {
        const {data} = await apiClient.get('/api/catalog/product/cross-sell/list', {
          params: {
            skus: this.skus,
            limit: this.limit
          }
        });

        return Array.isArray(data) ? data : [];
      } catch (e) {
        return [];
      }
    }

    private updated(): void {
      // Swiper needs a resize to pick up slides that arrived after mount.
      this.$nextTick(() => window.dispatchEvent(new UIEvent('resize')));
    }
  }
</script>
